import React from 'react'
import { RouteComponentProps } from 'react-router'
import { HowDoesItWork, MainLayout } from '../components'
interface PropsI extends RouteComponentProps {}
export const HowDoesItWorkPage: React.FC<PropsI> = props => {
	const { match } = props
	return (
		<MainLayout currentRoute={match.path}>
			<HowDoesItWork />
		</MainLayout>
	)
}
